export const LOGIN = '@@profile/LOGIN'
export const LOGINTOKEN = '@@profile/LOGINTOKEN'
export const LOGOUT = '@@profile/LOGOUT'
export const SET_EMAIL = '@@profile/SET_EMAIL'
export const SET_DISPLAYNAME = '@@profile/SET_DISPLAYNAME'
export const SET_LANG = '@@profile/SET_LANG'
export const SET_LOGIN_MODAL = '@@profile/SET_LOGIN_MODAL'

export interface SetEmailAction {
	type: typeof SET_EMAIL
	payload: string
}

export interface SetDisplayNameAction {
	type: typeof SET_DISPLAYNAME
	payload: string
}

export interface setLangAction {
	type: typeof SET_LANG
	payload: string
}

export interface setLoginModalAction {
	type: typeof SET_LOGIN_MODAL
	payload: {
		showLoginModal: boolean
		stickyLoginModal: boolean
	}
}

export interface ProfileState {
	readonly email: string
	readonly role: number
	readonly loggedIn: boolean
	readonly gravatarUrl: string
	readonly userId: string
	readonly location: string
	readonly displayName: string
	readonly lang: string | null
	readonly showLoginModal: boolean
	readonly stickyLoginModal: boolean
	readonly authenticated: boolean
	readonly accessToken: string
	readonly accessType: string
}

export interface LoginAction {
	type: typeof LOGIN
	payload: UserProfile
}

export interface LoginTokenAction {
	type: typeof LOGINTOKEN
	payload: UserProfile
}

export interface Logout {
	type: typeof LOGOUT
}

export interface Login {
	username: string
	password: string
	code?: string
	rememberMe: boolean
}

export interface LoginProfile {
	access_token: string
	expires_at: number
	expires_in: number
	refresh_token: string
	session_id: string
	token_type: string
	user: UserProfile
	user_id: string
	subscriptionChannel: string
	error: boolean
	errorResponse?: string
	lang: string
}

export interface UserProfile {
	displayName: string
	email: string
	gravatarUrl: string
	role: number
	userId: string
	lang: string
	authenticated: boolean
	loggedIn: boolean
}

export interface ProviderLogin extends UserProfile {
	accessToken: string
	refreshToken: string
}

export type ProfileActionTypes = SetDisplayNameAction | LoginAction | LoginTokenAction | Logout | SetEmailAction | setLangAction | setLoginModalAction
